(ns frontend.ui.component.lp-portal.report.body.innovestor.fund.pdf.pages.esg
  (:require
   [common.util :as cu]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]))

(defn image
  [data]
  (when-not (cu/blank-value? (:image data))
    (card/card
     ""
     {:image (str (:image data))
      :width 300}
     (text-content/optional-footer data))))

(defn esg-page
  [data]
  (let [{:keys [esg]} data]
    (page/page
     (page/page-title-with-line {:page-title "ESG summary" :toc-item true :reporting-period (:reporting-period data)})
     (column/half-columns
      (card/card
       ""
       (text-content/rich-content (->> esg
                                       :esg-summary
                                       :rich-content)))
      (image (:esg-image esg))))))

(defn esg-pages
  [data]
  (let []
    (when-not (cu/blank-value? (:reference-date data))
      (concat [(esg-page data)]))))
